var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause = function SvgIconPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.213 11.648V3.353c0-.788-.333-1.103-1.173-1.103H2.923c-.84 0-1.173.315-1.173 1.103v8.295c0 .787.333 1.102 1.172 1.102H5.04c.84 0 1.173-.315 1.173-1.102M12.25 11.648V3.353c0-.788-.332-1.103-1.172-1.103H8.96c-.834 0-1.172.315-1.172 1.103v8.295c0 .787.332 1.102 1.172 1.102h2.118c.84 0 1.172-.315 1.172-1.102"
  })));
};
export default SvgIconPause;